
    import { Component, Emit, Prop } from 'nuxt-property-decorator';
    import { namespace } from 'nuxt-property-decorator';
    import OptionsFieldsImage from '@/components/editor/options/fields/OptionsFieldsImage.vue';
    import ImageMixin from '@/mixins/imageMixin';
    import isObj from 'is-obj';

    const editor = namespace('editor');

    @Component({
        components: { OptionsFieldsImage }
    })
    export default class OptionsFieldsColor extends ImageMixin {
        @Prop() value!: any;
        @Prop() keyOption;
        @editor.Mutation setComponent;
        @editor.Action loadFile;

        color = {
            hex: this.value.hex,
            name: this.value.name,
            img: this.value.img
        };

        @Emit('input')
        setValue(value) {
            if (isObj(value) as any) {
                this.color.hex = value.currentTarget.value;
            } else {
                this.color.hex = value;
            }

            return this.color;
        }

        @Emit('input')
        setName(event) {
            this.color.name = event.target.value;
            return this.color;
        }

        @Emit('input')
        onImageChanged(val) {
            if (val) {
                this.color.img = { ...val };
            }
            //
            // if(typeof document !== "undefined" && val.src && !this.color.hex) {
            //     let img = document.createElement('img');
            //     img.src = this.imageSrc(val.src);
            //     img.width = 200;
            //     img.height = 200;

            //     this.color.hex = getAverageRGB(img);
            // }

            return this.color;
        }
    }
